import { Box } from '@mui/material';
import Popover from '@mui/material/Popover';
import styled from 'styled-components';

import { SizeCounter } from '@/features/canvas/components/SizeCounter';
import { getNodeRadius } from '@/features/canvas/utils/get-node-radius';

const SizePicker = ({
  anchorEl,
  handleEdit,
  sizeValue,
  handleClose,
  color,
}: {
  anchorEl: HTMLDivElement | null;
  color: string;
  handleClose: () => void;
  handleEdit: (newSize: number) => void;
  sizeValue: number;
}) => {
  const isOpen = Boolean(anchorEl);
  const id = isOpen ? 'size-popover' : undefined;

  const dotSize = getNodeRadius(sizeValue) * 2;

  return (
    <StyledPopover
      id={id}
      open={isOpen}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={{
        vertical: 'center',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'center',
        horizontal: 'left',
      }}
      PaperProps={{
        sx: {
          ml: '-11px',
        },
      }}
    >
      <PopoverContainer>
        <HalfBox>
          <SizeCounter value={sizeValue} onChange={handleEdit} />
        </HalfBox>
        <HalfBox>
          <StyledDot $dotSize={dotSize} $color={color} />
        </HalfBox>
      </PopoverContainer>
    </StyledPopover>
  );
};

const StyledPopover = styled(Popover)`
  .MuiPaper-root {
    box-shadow: rgba(0, 0, 0, 0.1) 0px 2px 8px;
    border-radius: 15px;
    padding: 0 5px;
    background: white;
    width: 169px;
    height: 93px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

const PopoverContainer = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
`;

const HalfBox = styled(Box)`
  width: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
`;

const StyledDot = styled.div<{ $color: string; $dotSize: number }>`
  width: ${({ $dotSize }) => $dotSize}px;
  height: ${({ $dotSize }) => $dotSize}px;
  background-color: ${({ $color }) => $color};
  border-radius: 50%;
`;

export { SizePicker };
